module.exports = __webpack_public_path__ + "static/media/ICON.c4070087.png";